import {
  ProductDetailsIntl,
  ProductDetailsTableIntl,
  ProductDetailsTabsIntl,
  ProductDetailsButtonsIntl,
} from 'types/i18n';

const tableIntl: ProductDetailsTableIntl = {
  descriptionTitle: 'Описание',
  activeTariffTitle: 'Активный тариф',
  latestTariffTitle: 'Следующий тариф',
  missingTariffSubTitle: 'Отсутствует',

  nameLabel: 'Название',
  createdAtLabel: 'Дата создания',
  partnerPercentLabel: 'Доля партнера, %',
  idLabel: 'ID',
  costLabel: 'Цена в мес, $',
  durationLabel: 'Период',
  durationValue(startsAt: string, expiresAt: string) {
    return `${startsAt} - ${expiresAt}`;
  },
};

const tabsIntl: ProductDetailsTabsIntl = {
  summaryTabTitle: 'О продукте',
  archiveTabTitle: 'Предыдущие тарифы',
};

const buttonsIntl: ProductDetailsButtonsIntl = {
  editProduct: 'Редактировать продукт',
  editTariff: 'Редактировать тариф',
  createTariff: 'Добавить тариф',
  deleteTariff: 'Удалить тариф',
};

export const productDetailsIntl: ProductDetailsIntl = {
  table: tableIntl,
  tabs: tabsIntl,
  buttons: buttonsIntl,
  productEditorTitle: 'Редактирование продукта',
  tariffEditorCreateTitle: 'Создание тарифа',
  tariffEditorUpdateTitle: 'Редактирование тарифа',
};
